<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.employee.createAbsence')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <form>
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.employee.createAbsence')}}</div>
                            <button type="button" @click="submit()"
                                class="btn btn-primary float-right">{{$t('button.save')}}</button>
                        </div>

                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>{{$t('form.employee.absenceType')}}<span
                                                class="text-danger">*</span></label>
                                        <v-select label="FullName" :options="staff"
                                            v-model.trim="$v.absence.staff_id.$model" :reduce="staff => staff.ID"
                                            :disabled="isNormalUser">
                                        </v-select>
                                        <div class="invalid-feedback custom-validate" v-if="invalidStaff">
                                            {{$t('form.validation.required')}}
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label>
                                            {{$t('form.employee.absenceFrom')}}<span class="text-danger">*</span>
                                        </label>
                                        <date-picker 
                                            :lang="lang"
                                            class="date-picker" v-model="absence.from" valueType="format"
                                            type="datetime" :format="datetimeFormat" :time-picker-options="timeOptions"
                                            :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                        </date-picker>
                                        <div class="invalid-feedback custom-validate" v-if="invalidFrom">
                                            {{$t('form.validation.required')}}</div>
                                    </div>

                                    <div class="form-group">
                                        <label>
                                            {{$t('form.employee.absenceTo')}}<span class="text-danger">*</span>
                                        </label>
                                        <date-picker :lang="lang" class="date-picker" v-model="absence.to" valueType="format"
                                            type="datetime" :format="datetimeFormat" :time-picker-options="timeOptions"
                                            :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                                        </date-picker>
                                        <div class="invalid-feedback custom-validate" v-if="invalidTo">
                                            {{$t('form.validation.required')}}</div>
                                    </div>

                                    <div class="form-group">
                                        <label>
                                            {{$t('form.employee.absenceReason')}}<span class="text-danger">*</span>
                                        </label>
                                        <v-select label="name" :options="reasons"
                                            v-model.trim="$v.absence.reason_id.$model" :reduce="reasons => reasons.id">
                                        </v-select>
                                        <div class="invalid-feedback custom-validate" v-if="invalidReason">
                                            {{$t('form.validation.required')}}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>
                                            {{$t('form.employee.absenceRemarks')}}
                                        </label>
                                        <textarea rows="12" class="form-control" v-model="absence.remarks"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";

    import {
        required,
        minLength,
        maxLength,
        email,
        integer
    } from "vuelidate/lib/validators";

    export default {
        props: ["permissions", "user", "datetimeFormat"],

        components: {
            vueDropzone: vue2Dropzone,
        },

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                invalidStaff: false,
                invalidReason: false,
                invalidFrom: false,
                invalidTo: false,

                timeOptions: {
                    start: '08:00',
                    step: '00:30',
                    end: '18:00',
                    format: 'HH:mm'
                },

                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },

                absence: {
                    staff_id: null,
                    from: this.formatDate(),
                    to: this.formatDate('18:00'),
                    reason_id: null,
                    remarks: null
                },
                staff: [],
                reasons: []
            }
        },

        validations: {
            absence: {
                staff_id: {
                    required,
                },
                from: {
                    required,
                },
                to: {
                    required,
                },
                reason_id: {
                    required
                }
            }
        },

        mounted() {
            if (!this.permissions.createEmployeeAbsences && this.partnerID != 1) {
                this.$router.push("/");
                return;
            }

            this.getInitialData();
        },

        computed: {
            isNormalUser() {
                if (this.user.staff_id) {
                    this.absence.staff_id = this.user.staff_id;
                }

                // HR & Admin Role Check
                if (!this.user.roles) return true;
                let founded = this.user.roles.find(r => r.slug == 'hr' || r.slug == 'admin');

                return founded ? false : true;
            },
            partnerID() {
                return this.user.partner_id;
            }
        },

        methods: {

            formatDate(timeStr = '08:00') {
                const dateObj = new Date();
                const dateStr = dateObj.toISOString().split('T').shift();

                return moment(dateStr + ' ' + timeStr).format(this.datetimeFormat);
            },

            getInitialData() {
                this.isLoading = true;

                axios
                    .get("/api/absences/initial-data")
                    .then(response => {
                        this.isLoading = false;

                        this.staff = response.data.staff;
                        this.reasons = response.data.reasons;

                        this.staff.map(s => s.FullName = `${s.FirstName} ${s.LastName}`);
                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },

            submit() {
                this.$v.$touch();

                this.invalidStaff = this.absence.staff_id == null ? true : false;
                this.invalidReason = this.absence.reason_id == null ? true : false;
                this.invalidFrom = this.absence.from == null ? true : false;
                this.invalidTo = this.absence.to == null ? true : false;

                if (this.$v.$invalid) {
                     
                    let errorMsg = '';
                      if(this.$v.absence.staff_id.$error){
                            errorMsg = this.$t('form.employee.absenceType');
                      }

                      if(this.$v.absence.from.$error){
                            errorMsg = errorMsg ? errorMsg +", "+this.$t('form.employee.absenceFrom'): this.$t('form.employee.absenceFrom');
                      }

                    if(this.$v.absence.to.$error){
                            errorMsg = errorMsg ? errorMsg +","+ this.$t('form.employee.absenceTo'): this.$t('form.employee.absenceTo');
                      }

                    if(this.$v.absence.reason_id.$error){
                            errorMsg = errorMsg ? errorMsg +" ,"+this.$t('form.employee.absenceReason'): this.$t('form.employee.absenceReason');
                      }


                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return; 
                }

                // validate to date must be greater than from date
                if (moment(this.absence.from, this.datetimeFormat) > moment(this.absence.to, this.datetimeFormat)) {
                    this.showAlert(this.$t('form.validation.greater'), 'danger');
                    return;
                }

                this.isLoading = true;

                axios
                    .post("/api/absences", this.absence)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.message) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'AbsenceIndex'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this.showAlert(this.$t('form.validation.error'), 'danger');
                    });
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>

<style scoped>
    .custom-validate {
        display: block !important;
    }

    .date-picker {
        display: block;
        width: 100% !important;
    }

</style>
